import { useNavigate, useLocation } from "react-router-dom";
import bhs from './bhs.js';

function VerticalNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = bhs(state => state.userRole);

  const allNavItems = [
    {
      name: "Dashboard",
      path: "/dashboard",
      hideForRoles: ["partner", "coach"],
    },
    // {
    //   name: "Administration",
    //   path: "/admin",
    //   hideForRoles: ["partner", "coach"],
    // },
    {
      name: "Coaches",
      path: "/coaches",
      hideForRoles: ["admin", "coach"],
    },
    {
      name: "Locations",
      path: "/locations",
      hideForRoles: ["partner", "coach"],
    },
    {
      name: "Partners",
      path: "/partners",
      hideForRoles: ["partner", "coach"],
    },
    {
      name: "Programs",
      path: "/location-programs",
      hideForRoles: ["admin", "coach"],
    },
    {
      name: "Programs",
      path: "/programs",
      hideForRoles: ["partner", "coach"],
    },
    {
      name: "Review Requests",
      path: "/reviews",
      hideForRoles: ["partner", "coach"],
    },
    {
      name: "Clients",
      path: "/clients"
    },
    {
      name: "Check-Ins",
      path: "/check-ins"
    },
    {
      name: "Settings",
      path: "/settings"
    },
  ];

  const navItems = allNavItems.filter(
    item => !item.hideForRoles || !item.hideForRoles.includes(userRole)
  );

  const handleNavigation = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="h-full">
      <div className="p-4">
        <ul className="space-y-2">
          {navItems.map((item, index) => (
            <li key={index}>
              <button
                onClick={() => handleNavigation(item.path)}
                className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-left transition-colors duration-200 ${
                  isActive(item.path)
                    ? 'bg-sky-50 text-indigo-500 border-l-4 border-blue-100'
                    : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                }`}
              >
                <span className="font-medium px-3">{item.name}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
      {/* <div className="absolute bottom-4 left-4 right-4"> */}
      {/*   <button */}
      {/*     onClick={() => navigate('/')} */}
      {/*     className="w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-red-600 hover:bg-red-50 transition-colors duration-200" */}
      {/*   > */}
      {/*     <span className="font-medium">Sign Out</span> */}
      {/*   </button> */}
      {/* </div> */}
    </nav>
  );
}

export default VerticalNavigation;
